"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexColumn, Table } from "@opensea/ui-kit";
import { ProfilePreviewTooltipCollectionTableFragment } from "./ProfilePreviewTooltipCollectionTable.fragment";
import { ProfilePreviewTooltipCollectionTableHeader } from "./ProfilePreviewTooltipCollectionTableHeader";
import { ProfilePreviewTooltipCollectionTableRow } from "./ProfilePreviewTooltipCollectionTableRow";
import { MAX_COLLECTIONS } from "./utils";
export function ProfilePreviewTooltipCollectionTable(t0) {
  const $ = _c(19);
  const {
    collections: collectionKeys
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== collectionKeys) {
    const collections = collectionKeys.map(_temp);
    T1 = FlexColumn;
    t5 = "w-full overflow-hidden";
    T0 = Table;
    t1 = "scrollbar-hidden";
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ProfilePreviewTooltipCollectionTableHeader />;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t3 = _temp2;
    t4 = collections.slice(0, MAX_COLLECTIONS);
    $[0] = collectionKeys;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t6 = <T0 contentClassName={t1} header={t2} itemKey={t3} items={t4} renderRow={ProfilePreviewTooltipCollectionTableRow} size="xs" />;
    $[9] = T0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== T1 || $[16] !== t5 || $[17] !== t6) {
    t7 = <T1 className={t5}>{t6}</T1>;
    $[15] = T1;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp2(_, index) {
  return index;
}
function _temp(collectionKey) {
  return readFragment(ProfilePreviewTooltipCollectionTableFragment, collectionKey);
}